export enum VacancyModerationEvents {
  Updated = 'VacancyModerationUpdated',
}
